<template>
  <div class="callback-container"></div>
</template>

<script>
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';
import { mapActions } from 'vuex';
import mixinPolitics from 'src/mixins/mixin-politics';
import { DISK_URL } from 'src/util/Util';

export default {
  name: 'AuthCallback',
  data() {
    return {
      model: {
        login: '',
        password: '',
        remember_me: false,
      },
    };
  },

  mixins: [mixinPolitics],
  methods: {
    /**
     *  mapeamos las acciones de nuestro store para poder llamarlas desde este script
     */
    ...mapActions({
      closeAllUserSessions: 'auth/closeAllUserSessions',
      passwordRequest: 'auth/passwordRequest',
      passwordReset: 'auth/passwordReset',
    }),
    getDISK_URL() {
      return DISK_URL;
    },
    handleActiveSession(message, username) {
      SweetAlert.default(
        i18n.t('vie.Pag.Aut.Login.activeSession'),
        `<p> ${message} </p>`,
        i18n.t('vie.Pag.Aut.Login.closeActiveSessions')
      ).then((result) => {
        if (result.value) {
          this.closeAllUserSessions(this.model).then((response) => {
            const DISK_URL = this.getDISK_URL();
            SweetAlert.success(response.data.message).then((result) => {
              if (result.value) {
                window.location.href = `${DISK_URL}auth/microsoft?lock=true`;
              } else {
                this.$router.replace('/login');
              }
            });
          });
        } else {
          this.$router.replace('/login');
        }
      });
    },
    passRequestEmail(user) {
      this.passwordRequest(user)
        .then((response) => {
          if (user.password_temporary) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.changePassword'),
              `<p> ${i18n.t('vie.Pag.Aut.Login.changePasswordText1')} </p>`,
              i18n.t('common_words.continue')
            ).then((result) => {
              if (result.value) {
                this.$router.push(
                  '/password_reset/' + response.data.data.token
                );
              }
            });
          } else {
            switch (response.data.code) {
              case 1:
                SweetAlert.success(response.data.message);
                break;
              case 2:
                SweetAlert.warning(response.data.message);
                break;
            }
          }

          this.isLoading = false;
        })
        .catch((e) => {
          const msg = e.response.data.message;
          if (error.response.data.code && error.response.data.code === 474) {
            SweetAlert.warning(msg);
          } else {
            SweetAlert.danger(msg);
          }
          this.isLoading = false;
        });
    },
  },
  async created() {
    const token = this.$route.query.token;
    const code = this.$route.query.code;
    const message = this.$route.query.message;
    this.model.login = this.$route.query.email;

    if (code == 1) {
      this.passRequestEmail({
        login: this.model.login,
        password_temporary: true,
      });
    }

    if (code == 2 || code == 3) {
      SweetAlert.warning(message);
      this.$router.replace({ path: '/login', query: {} });
    }

    if (code == 4) {
      this.handleActiveSession(message);
      return;
    }

    if (token) {
      localStorage.setItem('token', token);
      this.$axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const ok = await this.$store.dispatch('auth/attempt', token);

      if (ok) {
        this.$router.replace({ path: '/home' });
      } else {
        this.$router.replace('/login');
      }

      return;
    }
  },
};
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
}
</style>
